export default __webpack_public_path__ + "static/media/handycap01-1.bf531c51.png";